import { gql } from '@apollo/client';

export default gql`
  mutation editSpace($name: String!) {
    editSpace(input: { name: $name }) {
      space {
        id
        name
      }
    }
  }
`;
